import { render, staticRenderFns } from "./MemberSubscriptionAssign.vue?vue&type=template&id=351d8348"
import script from "./MemberSubscriptionAssign.vue?vue&type=script&lang=js"
export * from "./MemberSubscriptionAssign.vue?vue&type=script&lang=js"
import style0 from "./MemberSubscriptionAssign.vue?vue&type=style&index=0&id=351d8348&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports